export const PlotSVG = ({ fill = "#8a8a8a", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="50px"
    height="50px"
    fill="#8a8a8a"
    viewBox="0 0 32 32"
    {...props}
  >
    <path d="M30 32H20a2 2 0 0 1-2-2V20a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2zm0-12H20v10h10V20zm0-6H20a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2zm0-12H20v10h10V2zM12 32H2a2 2 0 0 1-2-2V20a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2zm0-12H2v10h10V20zm0-6H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2zm0-12H2v10h10V2z" />
  </svg>
);
export default PlotSVG;
